import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import $ from 'jquery';
import readXlsxFile from 'read-excel-file';
import XLSX from 'xlsx';
import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types';
import Sheet from '../../../../images/BIN_MASTER_v1.xlsx';
import Select from 'react-select';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';
import exportToCSV from '../../../Common/exportcsv';

var url =  window.location.hostname;
var port = window.location.port;
const Heading = [['HUL Code','Area Code']]




class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  


  constructor() {
   super();
   this.fetchBinData = this.fetchBinData.bind(this);
   this.openConfirm = this.openConfirm.bind(this);


    this.state = {
	  loading_overlay: false,	
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      loadingGRNData: false,
      showInvalidBaseItem:false,
      showInvalidProductItem:false,
      fileNameVal: 'masterFile',
      showResponseData: false,
      showBaseResponseData: false,
      showProductResponseData: false,
      responseUpdatedBaseData: false,
      responseUpdatedProductData: false,
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      postsBase: [],
      postsProduct: [],
      postsTester: [],
      tableRowsBase: [],
      tableRowsProduct: [],
      tableRowsTester: [],
      ErrorRowData: [],
      modal: false,
      modalFailed: false,
      ConfirmModal: false,
      Successmodal: false,
      loading: false,

      isLoading:true,
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      show_process_data: true,

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
     
    };
  }



  componentDidMount(){
  this.fetchBinData();
  }


  componentWillMount(){

      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }else{
          port = ":8088"
        }

      if (url === "localhost") {
        url= "15.206.34.41"+":8090";

      }else{
        url= window.location.hostname+port;
      }

      var cookieUsername = Util.getCookie('token');
      var location = Util.getCookie('selectedLocation');
      var username = Util.accessCookie("token");
      this.setState({
        userName: cookieUsername,
        selectedLocation: location
      })

      localStorage.setItem('userName' , username);
    }


  openConfirm(){
    this.setState({
      ConfirmModal: true
    })

  }




  fetchBinData(){


      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: false,
		loading_overlay:true
      })


     const payload={ master_type: "retialer_product_mapping",
     location: this.state.selectedLocation,}
API.post('/customer/view/v1/', { param: payload })
           

      .then(response => response.data)

      .then(data => {

         console.log("Area Data",data);

         // if (err) throw err;

         this.setState({posts: data.data })

      })

      .then(async() => {

         this.setState({ tableRows:this.assemblePosts(), isLoading:false })

         console.log(this.state.tableRows);

      });
  }


 

  assemblePosts= () => {

    let posts =this.state.posts.map((post) => {

      return (

        {

          area_code: post.area_code,

          retailer_code: post.retailer_code,
          type: post.type

          

        }

      )

    });

    this.setState({
      loading_overlay: false
    })

    return posts;

  }


  

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { selectedOption } = this.state;

    const data = {

      columns: [

        {

          label:'Area Code',

          field:'bin_id',
          sort: 'asc',

        },

        {

          label:'Hul Code',

          field:'retailer_code',
          sort: 'asc',

        },

        {

          label:'Type',

          field:'type',
          sort: 'asc',

        },

        

      ],

      rows:this.state.tableRows,

    }


    return (
      <Col xl={12}>
	       {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
           
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          

         


          {
            this.state.showFetchBinData  && (

          <CardBody style={{marginTop: 20}}>
            <div className="table_header" style={{borderBottomWidth:'0px'}}>
              
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Retailor Product Mapping</h4>
              
			  <span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.posts, "RetailorProductMaster", Heading)}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>

            </div>
			<hr style={{marginTop:'30px',marginBottom:'0px'}}/>
            <MDBDataTable
            striped
            bordered
            sortable={false}
            hover
            data={data}
            onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'retailer_product_master_view', 'datatable_pagination_change' )}
          />
          </CardBody>

          )}


        </Card>
    
      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));